import applyOverride from './applyOverride';

export function applyOverrides(data: any, overrides: any) {
    return Object.entries(overrides).reduce((acc, [name, override]) => applyOverride(acc, name, override), data);
}

export default applyOverrides;
